import Logger from './Logger';

class LoggerFactory {
  static get(name: string): Logger {
    return new Logger(name);
  }
}

export default LoggerFactory;
